// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"navigation__msignaturepad___3rnBf","m-signature-pad--body":"navigation__m-signature-pad--body___1Nczq","m-signature-pad--footer":"navigation__m-signature-pad--footer___33qWC","description":"navigation__description___2_yev","button":"navigation__button___1qU5J","clear":"navigation__clear___8Tq9_","save":"navigation__save___1rwEc","m-signature-pad":"navigation__m-signature-pad___1Dyy-","github":"navigation__github___3WnXf","horizontal":"navigation__horizontal___1QkT4"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/NavigationBar/navigation.scss
// module id = ivs0
// module chunks = client